import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

/**
 * A ShowHideHidden component is used to toggle one or multiple
 * parts of items in `ShowHide` component.
 *
 * @since 8.36.0
 */
export var ShowHideHidden = function ShowHideHidden(props) {
  var isHidden = props.isHidden,
    children = props.children;
  if (isHidden) {
    return null;
  }

  // eslint-disable-next-line zillow/react/jsx-no-useless-fragment
  return /*#__PURE__*/React.createElement(Fragment, null, children);
};
ShowHideHidden.displayName = 'ShowHideHidden';
ShowHideHidden.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The visibility of the content will be controlled by `isHidden`.
   */
  children: PropTypes.node,
  /**
   * Flag to display children content.
   */
  isHidden: PropTypes.bool
} : {};